var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_2143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1168 2.82756e-08H0.882446C0.39502 0.000244169 -0.000122042 0.39563 2.82756e-08 0.883179V15.1176C0.000244169 15.605 0.39563 16.0001 0.883179 16H15.1168C15.6045 16.0001 15.9999 15.6049 16 15.1172C16 15.1171 16 15.1169 16 15.1168V0.882446C15.9998 0.39502 15.6044 -0.000122042 15.1168 2.82756e-08Z",
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0469 16.0002V9.8127H13.1328L13.4453 7.39082H11.0469V5.84834C11.0469 5.14876 11.2411 4.67207 12.2443 4.67207H13.5156V2.5118C13.2944 2.48238 12.5355 2.41658 11.6525 2.41658C9.80872 2.41658 8.54688 3.54158 8.54688 5.60848V7.39082H6.46875V9.8127H8.54688V16.0002H11.0469Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_2143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.946ec2d8104097c73520da7b5b65eda2.svg";
export { ForwardRef as ReactComponent };